<template>
  <div class="par" :class="{ 'par--busy': busy }">
    <button type="button" class="par__main" @click="$emit('open')">
      <span class="par__tile">
        <img v-if="thumbnail" :src="thumbnail" :alt="activity.title" class="par__tile-img" />
        <v-icon v-else size="20" class="par__tile-icon">bhi-activity</v-icon>
      </span>
      <span class="par__text">
        <span class="par__title">{{ activity.title }}</span>
        <span v-if="activity.description" class="par__desc">{{ activity.description }}</span>
        <StarRating
          v-if="activity.rating"
          :value="activity.rating"
          :readonly="true"
          :size="14"
          class="par__rating"
        />
      </span>
    </button>

    <Toggle :value="!!activity.completed" :disabled="busy" @input="$emit('toggle', $event)" />
  </div>
</template>

<script>
import StarRating from '@/components/positiveActions/StarRating.vue'
import Toggle from '@/components/positiveActions/Toggle.vue'

/**
 * One positive action in the AM/PM list on the client-facing Positive Actions page. Mirrors the
 * mobile `ExercisesListItem`: thumbnail (or type icon), title, description, the read-only rating
 * once answered, and the done switch. Tapping the row opens the detail/answer sheet.
 */
export default {
  name: 'ActionRow',
  components: { StarRating, Toggle },
  props: {
    item: { type: Object, required: true },
    busy: { type: Boolean, default: false },
  },
  computed: {
    activity() {
      return this.item.activity
    },
    thumbnail() {
      const additional = this.activity.additionalMedia || {}
      const media = this.activity.media || {}
      const staticMedia = this.activity.mobileStaticMedia || {}
      return (
        additional.thumbnailUrl || media.thumbnailUrl || staticMedia.mediaUrl || null
      )
    },
  },
}
</script>

<style lang="scss" scoped>
$gray-new: #f6f6fa;
$gray-1: #52575c;
$black: #25282b;
$orange: #ed8938;

.par {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 80px;
  padding: 8px 8px 8px 8px;
  margin-bottom: 14px;
  border: 1px solid $gray-new;
  border-radius: 8px;

  &--busy {
    opacity: 0.6;
  }

  &__main {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    background: none;
    border: none;
    padding: 0;
    text-align: left;
    cursor: pointer;
  }
  &__tile {
    width: 64px;
    height: 64px;
    border-radius: 12px;
    background: $orange;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    overflow: hidden;
  }
  &__tile-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__tile-icon {
    color: #fff !important;
  }
  &__text {
    display: flex;
    flex-direction: column;
    padding-left: 16px;
    min-width: 0;
  }
  &__title {
    font-size: 14px;
    font-weight: 700;
    color: $black;
    // Two-line clamp, as the mobile row does.
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &__desc {
    font-size: 13px;
    color: $gray-1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &__rating {
    margin-top: 2px;
  }
}
</style>
